export const COMPANY_PROFILE_CREATION_URL = '/pages/new/company';
export const TEAMPERMISSIONS_URL = '/teampermissions';
